import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { add_hygiene_approval } from "../../../data/ApiEndpoints";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import { TASK_APPROVAL_STATUS } from "../../common-data/DropdowData";

const validateForm = (formValues) => {
  let errors = {};

  if (!formValues.selectedTaskStatus) {
    errors.selectedTaskStatus = "Required!";
  }

  if (!formValues.description) {
    errors.description = "Required!";
  }

  return errors;
};

const TaskApprovalForm = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading } = useSelector((state) => state.postApi);

  const forminitials = {
    selectedTaskStatus: "",
    description: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    setFormValues({ ...formValues, [name]: value });
  };

  const onSubmit = () => {
    setFormErrors(validateForm(formValues));
    setIsSubmit(true);
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = add_hygiene_approval;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(forminitials);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        request_id: rowData?.uid || "",
        status: formValues.selectedTaskStatus?.value || "",
        processed_description: formValues.description || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure!`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  return (
    <>
      <CommonHeadingNBtns
        title={`Change ${rowData?.task_name || "Task"} Status`}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading || loading}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="task_name" className={`formInputLabel `}>
              task name
            </label>

            <input
              type="text"
              placeholder="Task Name"
              className={`formInput`}
              name="task_name"
              value={rowData?.task_name}
              disabled
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedTaskStatus" className="formInputLabel">
              task status <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedTaskStatus ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={TASK_APPROVAL_STATUS}
                selectedOption={formValues.selectedTaskStatus}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown(selectedValue, "selectedTaskStatus")
                }
                name="Task Status"
              />
            </div>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="description" className="formInputLabel">
              task description <span className="required">*</span>
            </label>

            <textarea
              name="description"
              className={`formInput ${
                formErrors?.description ? "formError" : ""
              }`}
              placeholder="Enter Task Description"
              value={formValues.description}
              onChange={onChangeInput}
            ></textarea>
          </div>
        </div>
      </form>
    </>
  );
};

export default TaskApprovalForm;
